"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.nftCollectionHolders = exports.assetTransactionQuery = exports.nftHoldersQuery = exports.assetHoldersQuery = exports.assetQuery = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const common_1 = require("./common");
const types_1 = require("../types");
/**
 * @hidden
 *
 * Get Asset details for a given ticker
 */
function assetQuery(variables) {
    const query = (0, graphql_tag_1.default) `
    query AssetQuery($id: String!) {
      assets(filter: { id: { equalTo: $id } }) {
        nodes {
          eventIdx
          createdBlock {
            blockId
            datetime
            hash
          }
        }
      }
    }
  `;
    return {
        query,
        variables,
    };
}
exports.assetQuery = assetQuery;
/**
 * @hidden
 *
 * Get asset held by a DID
 */
function assetHoldersQuery(isSqIdPadded, filters, size, start, orderBy = types_1.AssetHoldersOrderBy.AssetIdAsc) {
    if (isSqIdPadded) {
        if (orderBy === types_1.AssetHoldersOrderBy.CreatedAtAsc) {
            orderBy = types_1.AssetHoldersOrderBy.CreatedBlockIdAsc;
        }
        if (orderBy === types_1.AssetHoldersOrderBy.CreatedAtDesc) {
            orderBy = types_1.AssetHoldersOrderBy.CreatedBlockIdDesc;
        }
    }
    const query = (0, graphql_tag_1.default) `
    query AssetHoldersQuery($identityId: String!, $size: Int, $start: Int) {
      assetHolders(
        filter: { identityId: { equalTo: $identityId } }
        first: $size
        offset: $start
        orderBy: [${orderBy}]
      ) {
        totalCount
        nodes {
          asset {
            id
            ticker
          }
        }
      }
    }
  `;
    return {
        query,
        variables: Object.assign(Object.assign({}, filters), (0, common_1.getSizeAndOffset)(size, start)),
    };
}
exports.assetHoldersQuery = assetHoldersQuery;
/**
 * @hidden
 *
 * Get NFTs held by a DID
 */
function nftHoldersQuery(isSqIdPadded, filters, size, start, orderBy = types_1.NftHoldersOrderBy.AssetIdAsc) {
    if (isSqIdPadded) {
        if (orderBy === types_1.NftHoldersOrderBy.CreatedAtAsc) {
            orderBy = types_1.NftHoldersOrderBy.CreatedBlockIdAsc;
        }
        if (orderBy === types_1.NftHoldersOrderBy.CreatedAtDesc) {
            orderBy = types_1.NftHoldersOrderBy.CreatedBlockIdDesc;
        }
    }
    const query = (0, graphql_tag_1.default) `
    query NftHolderQuery($identityId: String!, $size: Int, $start: Int) {
      nftHolders(
        filter: { identityId: { equalTo: $identityId } }
        first: $size
        offset: $start
        orderBy: [${orderBy}]
      ) {
        totalCount
        nodes {
          asset {
            id
            ticker
          }
          nftIds
        }
      }
    }
  `;
    return {
        query,
        variables: Object.assign(Object.assign({}, filters), (0, common_1.getSizeAndOffset)(size, start)),
    };
}
exports.nftHoldersQuery = nftHoldersQuery;
/**
 * @hidden
 *
 * Get the balance history for an Asset
 */
function assetTransactionQuery(paddedIds, filters, size, start) {
    const orderBy = paddedIds
        ? `${types_1.AssetTransactionsOrderBy.CreatedBlockIdAsc}`
        : `${types_1.AssetTransactionsOrderBy.CreatedAtAsc}, ${types_1.AssetTransactionsOrderBy.CreatedBlockIdAsc}`;
    const query = (0, graphql_tag_1.default) `
    query AssetTransactionQuery($assetId: String!) {
      assetTransactions(
        filter: { assetId: { equalTo: $assetId } }
        orderBy:  [${orderBy}]
      ) {
        totalCount
        nodes {
          asset {
            id
            ticker
          }
          amount
          nftIds
          fromPortfolioId
          toPortfolioId
          eventId
          eventIdx
          extrinsicIdx
          fundingRound
          instructionId
          instructionMemo
          datetime
          createdBlock {
            blockId
            hash
            datetime
          }
        }
      }
    }
  `;
    return {
        query,
        variables: Object.assign(Object.assign({}, filters), (0, common_1.getSizeAndOffset)(size, start)),
    };
}
exports.assetTransactionQuery = assetTransactionQuery;
/**
 * @hidden
 *
 * Get holders on an NFT Collection
 */
function nftCollectionHolders(assetId, size, start) {
    const query = (0, graphql_tag_1.default) `
    query NftCollectionHolders($assetId: String!, $size: Int, $start: Int) {
      nftHolders(
        first: $size
        offset: $start
        filter: { assetId: { equalTo: $assetId }, nftIds: { notEqualTo: [] } }
        orderBy: IDENTITY_ID_DESC
      ) {
        nodes {
          identityId
          nftIds
        }
        totalCount
      }
    }
  `;
    return {
        query,
        variables: Object.assign(Object.assign({}, (0, common_1.getSizeAndOffset)(size, start)), { assetId }),
    };
}
exports.nftCollectionHolders = nftCollectionHolders;
//# sourceMappingURL=assets.js.map